import React, {Component} from 'react'

import {
    Grid,
    GridCell,
    Spinner,
    css,
    Icon,
    Theme,
    Paginator,
    Select,
} from "@bdfx/mergado-ui-kit"

import {Option} from "@bdfx/mergado-ui-kit/lib/components/Form/Select";

import trans from "trans";
import {MERGADO_APP, superadminGetProductImages} from "app/helpers/api";
import {URL} from "app/config/api-config";
import {AxiosResponse} from "axios";

export const DEFAULT_PAGE_LIMIT = 50
export const productsPerPageOptions : Option[] = [25, DEFAULT_PAGE_LIMIT, 100].map((o : number) => ({label: `${o}`, value: `${o}`}))
export const specialOptions : Option[] = ['bgremoved', 'wmremoved', 'upscaled'].map((o) => ({label: trans(`${o}_image`), value: `${o}`}))

export type ProductsImagesType = {
    totalImages: number
    productImages: ProductImageType[]
    isRandom: boolean
    isgroupByImage: boolean
    isRecentFirst: boolean
    page: number
    maxPage: number
    limit: number
}

export type ProductImageType = {
    projectId: number
    templateId: number
    productId: number
    imageUrl: string
    imageUrlHash: string
    hasWatermarkMask: boolean
    productName: string
    templateName: string
    fieLink: string
    shopLink: string
    itemId: string
    templateUpdatedAt: string
    productUpdatedAt: string
    imageUpdatedAt: string
    renderedAt: string
}

interface Props {
    selectedProjectId: number
    selectedTemplateId: number
    selectedProductId: number
}

interface State {
    productsImages: ProductsImagesType
    getRandom: boolean
    groupByImage: boolean
    recentFirst: boolean
    special: string
    isLoading: boolean
}

class ProductsImages extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            productsImages: null,
            isLoading: false,
            getRandom: false,
            groupByImage: false,
            special: null,
            recentFirst: true,
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && JSON.stringify(prevProps) !== JSON.stringify(this.props) ||
            (prevState && prevState.special !== this.state.special)
        ) {
            this.getProductsImages(
                this.state.productsImages && this.state.productsImages.page ? this.state.productsImages.page : 1,
                this.state.productsImages && this.state.productsImages.limit ? this.state.productsImages.limit : DEFAULT_PAGE_LIMIT
            )
        }
    }

    getProductsImages = (page : number, limit : number) => {
        const {selectedProjectId, selectedTemplateId, selectedProductId} = this.props
        const {getRandom, groupByImage, recentFirst, special} = this.state

        superadminGetProductImages(selectedProjectId, selectedTemplateId, selectedProductId, page, limit, getRandom, groupByImage, recentFirst, special)
            .then((response: AxiosResponse<ProductsImagesType>) => {
                this.setState({productsImages: response.data})
            })
            .catch(error => {
                console.error(error.response)
            })
            .finally(() => {
                this.setState({isLoading: false})
            })
    }

    componentDidMount() {
        this.getProductsImages(1, DEFAULT_PAGE_LIMIT)
    }

    handlePageChange = (page) => {
        this.getProductsImages(page, this.state.productsImages.limit ?? DEFAULT_PAGE_LIMIT)
    }

    render() {
        const {isLoading, productsImages, special} = this.state

        if (isLoading) {
            return <div>Getting products info <Spinner type={'bubbles'} /></div>
        }

        if (!productsImages || !productsImages.productImages) {
            return <div />
        }

        const ts = new Date().getTime()

        return (
            <div>
                <h2>Products images ({productsImages.totalImages})</h2>

                <FiltersGrid>
                    <GridCell>
                    <Paginator
                        showFirstAndLast={true}
                        showPrevAndNext={true}
                        maxLinks={5}
                        labelFirst={`«« ${trans('first')}`}
                        labelPrevious={`« ${trans('previous')}`}
                        labelNext={`${trans('next')} »`}
                        labelLast={`${trans('last')} »»`}
                        currentPage={productsImages.page}
                        lastPage={productsImages.maxPage}
                        onPageChange={(page) => this.handlePageChange(page)}
                    />
                    </GridCell>
                    <GridCell>
                    <Select
                        options={productsPerPageOptions}
                        value={`${productsImages.limit}`}
                        onChange={(limit) => {
                            this.getProductsImages(1, limit)
                        }}
                    />
                    </GridCell>
                    <GridCell>
                        <Grid cols={'auto 200px'} gap={'10px'}>
                            <GridCell style={{textAlign: 'right', alignSelf: 'center'}}>{trans('type')}</GridCell>
                            <GridCell style={{' .muk-form-group': {marginBottom: '0px'}}}>
                                <Select
                                    options={specialOptions}
                                    value={special || ''}
                                    onChange={(special) => this.setState({special: special})}
                                />
                            </GridCell>
                        </Grid>
                    </GridCell>
                </FiltersGrid>

                <StyledProductGrid dataSpecial={special}>
                    {productsImages.productImages.map(productImage => {
                        return <GridCell key={productImage.productId} className={'shadow-box'}>
                            <div title={`P: ${productImage.templateUpdatedAt}, T: ${productImage.productUpdatedAt}, I: ${productImage.imageUpdatedAt}, R: ${productImage.renderedAt}`}>{productImage.productId}</div>
                            <div>{productImage.templateName}</div>

                            {productImage.hasWatermarkMask ?
                                <FourImagesGrid>
                                    <GridCell>
                                        <a href={productImage.imageUrl} target={'_blank'}>
                                            <img className={'product-image shadow-box checker'} src={productImage.imageUrl} title={productImage.imageUrl}/>
                                        </a>
                                    </GridCell>
                                    <GridCell>
                                        <img src={`${URL.laravelBase}get-wmremoved/${productImage.projectId}/${productImage.imageUrlHash}?ts=${ts}`} className="product-image shadow-box checker"/>
                                    </GridCell>
                                    <GridCell>
                                        <img src={`${URL.laravelBase}get-wmmask/${productImage.projectId}/${productImage.imageUrlHash}?ts=${ts}`} className="product-image shadow-box checker"/>
                                    </GridCell>
                                    <GridCell>
                                        <a href={productImage.fieLink} target={'_blank'}>
                                            <img className={'product-image checker'} src={productImage.fieLink} title={productImage.productName}/>
                                        </a>
                                    </GridCell>
                                </FourImagesGrid>
                                :
                                <div style={{height: '200px', marginBottom: '5px'}}>
                                    <a href={productImage.fieLink} target={'_blank'}>
                                        <img className={'product-image checker'} src={productImage.fieLink} title={productImage.productName}/>
                                    </a>
                                </div>
                            }

                            <div>
                                {productImage.imageUrl ?
                                <a href={productImage.imageUrl} target={'_blank'} className={'links'}>
                                    <Icon type={'image-light'} size={iconSize}/>
                                </a> : <span title={trans('filter_no_image')}>
                                    <Icon type={'times-circle-o'} size={iconSize} color={Theme.red} />
                                </span>
                                }

                            <a href={productImage.shopLink} target={'_blank'} className={'links'} title={trans('link_eshop')}>
                                <Icon type={'link-light'} size={iconSize} />
                            </a>

                            <a href={`${URL.publicPath}eshop/1/project/${productImage.projectId}/templates/${productImage.templateId}/edit`} target={'_blank'} className={'links'} title={trans('edit_template')}>
                                <Icon type={'edit-light'} size={iconSize} />
                            </a>

                            <a href={`${MERGADO_APP}/${productImage.productId}`} target={'_blank'} className={'links'} title={trans('link_mergado')}>
                                <Icon type={'mergado'} size={iconSize} />
                            </a>

                            <span className={'links'} title={`item id ${productImage.itemId}`}>
                                <Icon type={'tag'} size={iconSize} />
                            </span>

                            </div>
                        </GridCell>
                    })}
                </StyledProductGrid>
            </div>
        )
    }
}

export const iconSize = 20

export const FiltersGrid = css(Grid)({
    gridTemplateColumns: '1fr 100px 1fr',
    gridGap: '5px',
})

export const StyledProductGrid = css(Grid)({
    gridTemplateColumns: `repeat(auto-fit, minmax(200px, 1fr))`,
    gridGap: '5px',
    marginTop: '20px',
    ' .muk-gridcell': {
        height: '100%',
        padding: '10px',
        backgroundColor: '#c0c0c0',
        alignSelf: 'center',
        textAlign: 'center',
        verticalAlign: 'middle',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: '#efefef',
        },
    },
    ' img.product-image': {
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        border: '1px solid gray',
    },
    ' img.template-image': {
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    ' .links': {
        padding: 10,
    },
    ' .template-is-active': {
        fontWeight: 'bold',
    },
    ' .active': {
        color: Theme.green,
    },
    ' .inactive': {
        color: Theme.orange,
    }
}, props => {
    const isWide = props.dataSpecial === 'wmremoved'
    return {
        gridTemplateColumns: `repeat(auto-fit, minmax(${isWide ? 400 : 200}px, 1fr))`,
    }
})

export const FourImagesGrid = css(Grid)({
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '180px',
    gridGap: '10px',
    height: '360px',
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
    },
    ' img': {
        width: 'auto',
        height: 'auto',
        maxHeight: '180px',
        maxWidth: '180px',
    }
})

export default ProductsImages